import app_img from '@/public/article/App.webp';
import managment_img from '@/public/article/Customer management.webp';
import invoicing from '@/public/article/Invoice.webp';
import article1 from '@/public/article/picture.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import main_bg from '@/public/industries/handyman/handyman.webp';
import image4 from '@/public/industries/hvac/Reporting-and-analytics.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'What are the Benefits of Field Service Management Software?',
    text: `Implementing field service software brings numerous advantages, including operational
    efficiency, reduced costs, and elevated customer satisfaction. It streamlines critical business
    processes such as scheduling, dispatching, and billing, ensuring tasks are completed more
    efficiently and effectively. Moreover, real-time visibility into field operations enables better
    resource allocation and decision-making, while improved communication channels enhance
    customer engagement and service quality.`,
  },
  {
    title: `How Much Does Field Service Management Software Cost?`,
    text: `The cost of service business software varies based on the features and functionality required
    by your business. Orcatec offers a flexible pricing model, starting with a free starter package
    that allows businesses to explore its features without financial commitment. Beyond the starter
    package, Orcatec provides customizable paid options, enabling businesses to select and pay
    for only the features they need, ensuring cost-effectiveness and scalability.`,
  },
  {
    title: 'What are Some Common Field Service Management Software Features?',
    text: `Common features of free field service management software include scheduling and
    dispatching tools, customer management databases, invoicing and billing capabilities, and real-
    
    time tracking and reporting functions. These features work together to optimize business
    operations, improve communication with customers, streamline financial processes, and provide
    actionable insights into field activities, making it easier for businesses to manage their day-to-
    day operations and grow.`,
  },

  {
    title: 'How Field Service Management Software Can Help Small Businesses?',
    text: `For small businesses, free field service software is a powerful tool that levels the playing field,
    allowing them to compete with larger entities. By automating and optimizing various aspects of
    their operations, small businesses can achieve greater efficiency, reduce operational costs, and
    enhance customer satisfaction. This software provides small businesses with the capabilities to
    manage their resources more effectively, respond to customer needs promptly, and make
    informed decisions based on real-time data, ultimately supporting their growth and success in a
    competitive market.`,
  },
];

const testimonals = [
  {
    text: `Switching to Orcatec was a game-changer for our HVAC company. The ability to track service
    calls in real-time and dispatch technicians with a few clicks has dramatically increased our
    efficiency. Our customers love the speedy response times! We’re now handling more calls daily
    with the same staff – it’s incredible.`,
    name: 'Linda R.,',
    position: 'Cool &amp; Cozy HVAC',
  },
  {
    text: `Orcatec Manager has taken our electrical service company to the next level. The software's
    easy-to-use interface and robust reporting tools mean we spend less time on paperwork and
    more time helping customers. The mobile app ensures our field technicians are always
    connected, making miscommunication a thing of the past.`,
    name: 'Jamal S.,',
    position: 'Bright Spark Electricals',
  },
  {
    text: `As a growing landscaping business, finding the right service management tool was critical.
    Orcatec Tools offered us a solution that not only manages client appointments seamlessly but
    also tracks our equipment and inventory efficiently. The software's reliability and support have
    made it an essential part of our daily operations.`,
    name: 'Emily T.,',
    position: 'GreenScape Gardeners',
  },
  {
    text: `Switching to Orcatec was a game-changer for our HVAC company. The ability to track service
    calls in real-time and dispatch technicians with a few clicks has dramatically increased our
    efficiency. Our customers love the speedy response times! We’re now handling more calls daily
    with the same staff – it’s incredible.`,
    name: 'Linda R.,',
    position: 'Cool &amp; Cozy HVAC',
  },
  {
    text: `Orcatec Manager has taken our electrical service company to the next level. The software's
    easy-to-use interface and robust reporting tools mean we spend less time on paperwork and
    more time helping customers. The mobile app ensures our field technicians are always
    connected, making miscommunication a thing of the past.`,
    name: 'Jamal S.,',
    position: 'Bright Spark Electricals',
  },
  {
    text: `As a growing landscaping business, finding the right service management tool was critical.
    Orcatec Tools offered us a solution that not only manages client appointments seamlessly but
    also tracks our equipment and inventory efficiently. The software's reliability and support have
    made it an essential part of our daily operations.`,
    name: 'Emily T.,',
    position: 'GreenScape Gardeners',
  },
];

const industries = {
  title: 'Our industries',
  description: `Orcatec is a flexible platform that is suitable for companies providing field services. We designed our field service management software to meet the diverse needs.`,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES_HOME_CLEANING,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES_HANDYMAN,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES_CONSTRUCTION,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Field Services Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Optimized Field Service Scheduling',
      },
      href: '#',
      tag: 'Job Scheduling',
      title: `Optimized Field Service Scheduling`,
      text: `Enhance your field technicians' efficiency with our sophisticated scheduling tool designed
      specifically for service-oriented businesses. This platform empowers your technicians to actively
      
      manage their schedules, access job details, and update job statuses in real-time, directly from
      the field. By providing the ability to adjust their workflow based on skillset, location, and real-
      time availability, our software significantly improves operational effectiveness.`,
      list: [
        { text: 'Efficient job planning and scheduling.' },
        { text: 'Minimization of scheduling overlaps.' },
        { text: 'Optimal resource allocation for various job types.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer management',
      },
      href: '#',
      tag: 'Customer management',
      title: 'Real-Time Tracking and Management',
      text: `Stay in command of your field operations through our comprehensive real-time tracking
      features. Monitor the progress of each task as it happens, and manage your resources with
      precision. This oversight ensures that every job is conducted efficiently, with the ability to make
      dynamic adjustments that contribute to effectiveness and customer satisfaction.`,
      list: [
        { text: 'Detailed tracking of customer interactions and inquiries.' },
        { text: 'Management of customer preferences and individual needs.' },
        { text: 'Comprehensive service history recording for each client.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: invoicing,
        alt: 'Simplified Invoicing and Payments',
      },
      href: '#',
      tag: 'Invoicing and Payments',
      title: 'Invoicing and Payment Processing',
      text: `Our software simplifies the financial aspect of your business with automated invoicing and
      payment processing. This system reduces the necessity for manual invoicing, ensuring your
      technicians can issue bills and accept payments directly from the customer's location, using a
      mobile device. This efficiency reduces paperwork and administrative strain, enabling you to
      focus more on your core business activities.`,

      list: [
        { text: 'Automated invoicing and billing process.' },
        { text: 'Reduction of billing errors and discrepancies.' },
        { text: 'Easy tracking and management of financial transactions.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: image4.src,
        alt: 'Reporting and analytics',
      },
      href: '#',
      tag: 'Reporting and analytics',
      title: 'Customer Communication and Feedback',
      text: `Forge stronger relationships with your clients using our dedicated communication tools. Provide
      updates, receive instant feedback, and engage in meaningful dialogue to understand your
      customers' needs better. This direct line of communication not only helps in tailoring your
      services to client expectations but also significantly enhances the quality of your customer
      service.`,
      list: [
        { text: 'Insightful business analytics and customizable reports.' },
        { text: 'Monitoring of performance metrics and customer engagement.' },
        { text: 'Data analysis tools for strategic decision-making.' },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Field Service Management Software',
  title: {
    first_part: 'Optimize Every Aspect of Your Service Business - ',
    second_part: 'From the First Call to The Final Bill',
  },
  description: `In fast-changing service management, staying ahead means leveraging the best tools to
  streamline operations, enhance efficiency, and ensure customer satisfaction. Field services
  software like Orcatec emerges as a game-changer for businesses aiming to achieve these
  goals, providing a comprehensive suite of solutions tailored to service-oriented companies'
  dynamic needs.`,
  info: [
    { title: '40 hours', description: 'Reduced Monthly Paperwork' },
    { title: '35%', description: 'Workforce Productivity' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1.src,
    alt: 'What is Field Services Software?',
  },
  title: 'What is Field Services Software?',
  description: `At the heart of innovative service management solutions, Orcatec's field services software
  stands out. Designed to cater to the unique demands of the service industry, this robust field
  management software offers a seamless, intuitive platform for managing all aspects of field
  service operations. By addressing common challenges such as scheduling, dispatch, invoicing,
  and customer communication, Orcatec’s solution ensures that businesses can focus more on
  delivering quality service and less on administrative burdens.`,
  item: [
    {
      title: 'Increased Productivity',
      description: `Orcatec’s platform uses intelligent algorithms to optimize schedules and dispatch
        cleaners based on location, availability, and customer preferences.`,
    },
    {
      title: 'Improved Customer Service',
      description: `The software provides a centralized database for all customer information, including
        preferences, service history, and payment records.`,
    },
    {
      title: 'Easy Control of All Processes',
      description: `Orcatec streamlines the billing process by automatically generating invoices based on
        completed services and processing payments securely online, improving cash flow and
        reducing administrative overhead.`,
    },
    {
      title: 'Inventory Management',
      description: `With built-in communication tools, cleaning businesses can offer their clients real-time
        updates and notifications, enhancing customer satisfaction and trust.`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Orcatec Is Right For You?',
  },
  title: 'Why Orcatec Is Right For You?',
  description: `Choosing Orcatec's Field Services Software means more than just accessing a powerful
  technological tool. It means partnering with a provider that understands the needs of service
  businesses and offers a solution that is:`,
  item: [
    {
      title: 'Free Version Access',
      description: `Begin with no upfront costs and experience the software's
      capabilities firsthand.`,
    },
    {
      title: 'Flexible Paid Functionality',
      description: `Only pay for what you need, customizing the software to fit
      your business requirements.`,
    },
    {
      title: 'Easy Customization.',
      description: `Tailor the software to your operations, ensuring it works for you, not
      the other way around.`,
    },
    {
      title: 'Cross-platform Accessibility',
      description: `Access your management tools from anywhere, on any
      device – PC, tablet, or mobile, across iOS and Android platforms.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Welcome to the pulse of the field services industry – the Orcatec blog. Here, we delve into the
  latest trends, share expert insights, and offer practical advice tailored for service business
  professionals. Join us as we explore innovative strategies to elevate your operations and
  achieve business excellence.`,
};

const bookDemo = {
  title: `Unlock Your Business's Full Potential with Orcatec`,
  description: `Ready to take your field services business to the next level? Orcatec’s comprehensive suite of
  tools is here to pave the way for enhanced efficiency, streamlined operations, and unparalleled
  customer satisfaction. Fill out the form below to get in touch with our experts, schedule a free
  demo, or start your journey with our free starter package. Let Orcatec be the solution you’ve
  been searching for.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
